import React, { useState, useEffect, useMemo } from 'react'
import './PagePush.scss'

import { hostDetect } from '../../config/envConfig';
import axios from "axios/index";

import { connect } from 'react-redux';

import { setAlert } from '../../redux/actions/alertActions';

import DateRange from './DateRange/DateRange';

import ApexChart from './ChartTable/ChartTable.js';

import Pagination from './Pagination/Pagination.js'

import MobileHeader from '../../components/commonComponents/mobileHeader/MobileHeader.js';

// moment js
import moment from 'moment'
import 'moment/locale/ru'
moment.locale('ru')



const PagePush = ({currentSiteID, setAlert}) => {
    const [apiLoading, setApiLoading] = useState(false)

    const [startDate, setStartDate] = useState(moment().startOf('month'))
    const [endDate, setEndDate] = useState(moment())

    const [totalStat, setTotalStat] = useState(null)
	const [detailedStat, setDetailedStat] = useState([])

    const [test_data, set_test_data] = useState(true)

    // pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(10)
    const [paginationStart, setPaginationStart] = useState(0)
    const [paginationEnd, setPaginationEnd] = useState(0)

    // sorting
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc'
    });


    function fetch(){
        setSortConfig({ ...sortConfig, key: null })

        setApiLoading(true)

        axios.get(`${hostDetect('api')}/push-statistics/income?site_id=${currentSiteID}&start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`, {
            withCredentials: true
          })
          .then(res => {
            if(res.data.success){
    
                setTotalStat(res.data.data.total.total)

                const transformedData = res.data.data.total.by_date.map(item => {
                    const newItem = {};
                    for (const key in item) {
                      if (key === 'date') {
                        newItem[key] = item[key];
                      } else {
                        newItem[key] = Number(item[key]);
                      }
                    }
                    return newItem;
                });

                setDetailedStat(transformedData.reverse())
              
            } else {
              const errorMessage = res.data.data.message
              setAlert('error', errorMessage);
            }
    
            // hide loader
            setApiLoading(false)
          })
          .catch(err => {
            // hide loader
            setApiLoading(false)
            setAlert('error', 'Не получилось отправить запрос!');
          })
    }

    useEffect(()=>{
        if(currentSiteID && startDate && endDate){
            fetch()
        }
    }, [currentSiteID])


    // pagination controls
    let indexFirst = num => {
        setPaginationStart(num)
    }
    
    let indexLast = num => {
        setPaginationEnd(num)
    }
    

    // cut symbols after dot
    function truncateToDecimal(number, decimalPlaces = 1) {
        const str = number.toString();
        
        const decimalIndex = str.indexOf('.');
    
        if (decimalIndex === -1) {
            return number;
        }
    
        const truncated = str.slice(0, decimalIndex + decimalPlaces + 1);
    
        return parseFloat(truncated);
    }

    // format integers
    function formatInteger(number, locale = 'ru-RU') {
        const formatter = new Intl.NumberFormat(locale, {
            useGrouping: true,
        });
        return formatter.format(number);
    }


    // sorting
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
          direction = 'desc';
        }
        setSortConfig({ key, direction });
    }
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return detailedStat;
        
        return [...detailedStat].sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? 1 : -1;
          }
          return 0;
        });
    }, [detailedStat, sortConfig]);



    return (
        <div className="page-push">
            <MobileHeader/>
            <div className="page-push__wrap">

                {
                    apiLoading ? 
                        <div className="loader__small">
                            Загрузка данных...
                        </div> : null
                }

                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-2">
                        <div className='page-push-controls-wrap'>
                            <DateRange startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
                            <button className="btn btn-primary ml-2" onClick={fetch}>Применить</button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-2">
                        <ApexChart sortedData={detailedStat} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                       
                        <div className="table-responsive info-tables">
                            <table className="table table-bordered">
                                <thead className="thead-light">
                                    <tr className="text-center">
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'date' ? sortConfig.direction : ''}`}
                                            onClick={() => requestSort('date')}>
                                            Дата
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'requests' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('requests')}>
                                            Запросы
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'subscriptions' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('subscriptions')}>
                                            Подписались
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'notifications' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('notifications')}>
                                            Уведомлений показано
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'clicks' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('clicks')}>
                                            Клики
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'profit' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('profit')}>
                                            Доход, ₽
                                        </th>
                                        {/* <th scope="col">Разделение дохода</th> */}
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'subscriptions_percent' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('subscriptions_percent')}>
                                            Процент подписок, %
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'ctr' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('ctr')}>
                                            CTR
                                        </th>
                                        <th 
                                            scope="col" 
                                            className={`sortable ${sortConfig.key === 'cpm' ? sortConfig.direction : ''}`} 
                                            onClick={() => requestSort('cpm')}>
                                            CPM
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sortedData.length ? sortedData.slice(paginationStart, paginationEnd).map((item, i) => (
                                            <tr className="text-center font-weight-bold" key={i}>
                                                <td>{ item.date }</td>
                                                <td>{ formatInteger(item.requests) }</td>
                                                <td>{ formatInteger(item.subscriptions) }</td>
                                                <td>{ formatInteger(item.notifications) }</td>
                                                <td>{ formatInteger(item.clicks) }</td>
                                                <td>{ formatInteger(item.profit) }</td>
                                                {/* <td>{item.revenue_share}</td> */}
                                                <td>{ truncateToDecimal(item.subscriptions_percent, 1) }</td>
                                                <td>{ truncateToDecimal(item.ctr, 1) }</td>
                                                <td>{ truncateToDecimal(item.cpm, 1) }</td>
                                            </tr>
                                        ))
                                        : <tr>
                                            <td colSpan="9">Данные отсутствуют</td>
                                        </tr>
                                    }
                                    {
                                        totalStat ? (
                                            <tr className="text-center font-weight-bold" style={{background: '#e9e9e9'}}>
                                                <td>Суммарно:</td>
                                                <td>{ formatInteger(totalStat.requests) }</td>
                                                <td>{ formatInteger(totalStat.subscriptions) }</td>
                                                <td>{ formatInteger(totalStat.notifications) }</td>
                                                <td>{ formatInteger(totalStat.clicks) }</td>
                                                <td>{ formatInteger(totalStat.profit) }</td>
                                                <td>{ truncateToDecimal(totalStat.subscriptions_percent, 1) }</td>
                                                <td>{ truncateToDecimal(totalStat.ctr, 1) }</td>
                                                <td>{ truncateToDecimal(totalStat.cpm, 1) }</td>
                                            </tr>
                                        ) : null
                                    }
                                    
                                </tbody>
                            </table>
                        </div>

                        <div className='mt-2'>
                            {
                                detailedStat.length ? (
                                    <Pagination
                                        currentPage={currentPage}
                                        postsPerPage={postsPerPage}
                                        notPaginateStat={detailedStat}
                                        setCurrentPage={setCurrentPage}
                                        size={detailedStat.length}
                                        indexOfFirst={indexFirst}
                                        indexOfLast={indexLast}/>
                                ) : null
                            }
                        </div>

                    </div>
                </div>              
            </div>
        </div>
    )
}

function mapStateToProps(state){
    return{
      currentSiteInfo: state.siteInfo.site,
      currentSiteID: state.siteInfo.site.id
    }
}

const mapDispatchToProps = {
    setAlert
}


export default connect(mapStateToProps, mapDispatchToProps)(PagePush)